import {
    createTheme,
    type PaletteColorOptions,
    type PaletteMode,
    type ThemeOptions,
} from "@mui/material";

import { ThemeOverridesConfiguration } from "types/AppConfig";

export const iCoppTheme = (
    mode: PaletteMode,
    themeOverrides?: ThemeOverridesConfiguration,
) => {
    let generalThemeObject: ThemeOptions = {
        palette: {
            mode: mode,
            primary: {
                main: !themeOverrides?.mainColor
                    ? "#fe7000"
                    : themeOverrides.mainColor,
                contrastText: "#ffffff",
                clubType: "#fc9403",
            } as PaletteColorOptions,
            secondary: {
                main: "#6131ad",
            },
            tertiary: {
                main: "#fc9d03",
                contrastText: "#fff",
            },
            alwaysWhite: {
                light: "#fff",
                main: "#fff",
                dark: "#fff",
                contrastText: "#fff",
            },
            info: {
                main: "#7adec9",
            },
        },
        typography: {
            buttonCondensed: {
                fontSize: ".875rem",
                lineHeight: 1.4,
            },
        },
    };

    if (mode === "dark" && themeOverrides?.mainColor) {
        generalThemeObject = {
            ...generalThemeObject,
            components: {
                MuiAppBar: {
                    styleOverrides: {
                        root: {
                            backgroundColor: themeOverrides.mainColor,
                        },
                    },
                },
            },
        };
    }

    const createdTheme = createTheme({
        ...generalThemeObject,
        palette: {
            ...generalThemeObject.palette,
            mode,
        },
    });

    return createdTheme;
};

declare module "@mui/material/styles" {
    // allow configuration using `createTheme`
    interface TypographyVariantsOptions {
        buttonCondensed?: React.CSSProperties;
    }

    interface PaletteOptions {
        tertiary?: PaletteColorOptions;
        alwaysWhite?: PaletteColorOptions;
    }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        buttonCondensed: true;
    }
}

declare module "@mui/material/Chip" {
    export interface ChipPropsColorOverrides {
        tertiary: true;
    }
}

declare module "@mui/material/IconButton" {
    export interface IconButtonPropsColorOverrides {
        alwaysWhite: true;
    }
}
